module.exports = __webpack_public_path__ + "img/icon1.09f71cb9.png";